import { EntityLayout } from '@backstage/plugin-catalog';

import { overviewContent } from '../overviewContent/overviewContent';
import { technicalDocumentationContent } from '../technicalDocumentationContent';

export const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {technicalDocumentationContent}
    </EntityLayout.Route>
  </EntityLayout>
);
